import Navbar from './components/Navbar';
import Hero from './components/Hero';
import CategoryGrid1 from './components/CategoryGrid1';
import FeatureGrid from './components/FeatureGrid';
import CategoryGrid2 from './components/CategoryGrid2';
import CategoryGrid3 from './components/CategoryGrid3';
import AboutSection from './components/AboutSection';
import TestimonialSection from './components/TestimonialSection';
import CTASection from './components/CTASection';
import Footer from './components/Footer';
import JsonLd from '@/components/base/JsonLd';

export default function Home() {
  const siteUrl = (typeof import.meta !== 'undefined' && (import.meta as Record<string, unknown>).env && ((import.meta as Record<string, unknown>).env as Record<string, string>).VITE_SITE_URL) || 'https://cssspreadsheet.casa';
  const organization = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: 'CSSSpreadsheet.casa',
    url: siteUrl,
    description: 'Independent CSSBuy spreadsheet resource center with curated shopping links, verified seller guides, QC tips, and brand indexes for replica fashion shoppers.',
    sameAs: ['https://kaspreadsheet.com'],
  };
  const website = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: 'CSSSpreadsheet.casa',
    url: siteUrl,
    description: 'CSSBuy Spreadsheet Resource Hub — Curated Shopping Links & Guides for replica fashion buyers.',
    potentialAction: {
      '@type': 'SearchAction',
      target: { '@type': 'EntryPoint', urlTemplate: `${siteUrl}/search?q={search_term_string}` },
      'query-input': 'required name=search_term_string',
    },
  };
  const breadcrumb = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      { '@type': 'ListItem', position: 1, name: 'Home', item: siteUrl },
    ],
  };

  return (
    <main>
      <JsonLd data={organization} />
      <JsonLd data={website} />
      <JsonLd data={breadcrumb} />
      <Navbar />
      <article>
        <Hero />
        <CategoryGrid1 />
        <FeatureGrid />
        <CategoryGrid2 />
        <CategoryGrid3 />
        <AboutSection />
        <TestimonialSection />
        <CTASection />
      </article>
      <Footer />
    </main>
  );
}